export default __webpack_public_path__ + "static/media/GPUImg.923f4787.jpg";